import PropTypes from 'prop-types';
import React, { useState, useMemo, useEffect } from 'react';
// material-ui
import { Container, Box, Toolbar, useMediaQuery, useTheme } from '@mui/material';
import { useLocation, useHistory } from 'react-router-dom';
import { useQuery } from 'react-query';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';
import { useElectricPage } from '../../helpers/isElectricPage';
import { ROUTES } from '../../constants';
import { useToast } from '../../hooks/ToastProvider';
import useGlobalMutation from '../../hooks/useGlobalMutation';
import { DELETE_PROFILE } from '../../redux/_user.redux';
import { clearReturnPath, getReturnPath } from '../../helpers/routeHistory';
import { useDispatch } from 'react-redux';
import { logout } from '../../api/AuthApi';
import { getContracts } from '../../api/ElectricApi';
import { stopImpersonating } from '../../helpers/auth';
import FloatingBear from '../../components/login/FloatingBear';
import GlobalNotification from '../../components/login/GlobalNotification';

//-----------------------|| MAIN LAYOUT ||-----------------------//

const MainLayout = ({ children, isNotPublicPage }) => {
    const { showToast } = useToast();
    const dispatch = useDispatch();
    const history = useHistory();
    const isElectricPage = useElectricPage();
    const location = useLocation();
    const isLoginPage = location.pathname === ROUTES.LOGIN;
    const isForgetPasswordPage = location.pathname === ROUTES.FORGET_PASSWORD || location.pathname === ROUTES.FORGET_PASSWORD_SENT;
    const shouldHideFooter = isLoginPage || isForgetPasswordPage;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const logoutMutation = useGlobalMutation(logout, {
        onSuccess: async () => {
            ['token', 'auth.token', 'auth.refreshToken', 'auth.credential'].forEach((k) => localStorage.removeItem(k));
            dispatch({ type: DELETE_PROFILE });
            stopImpersonating();
            clearReturnPath();
            history.push(ROUTES.LOGIN);
        },
        onError: () => showToast()
    });

    const { data: contractsResponse } = useQuery(['getContracts'], () => getContracts(1, 1000), {
        enabled: isElectricPage
    });
    const hasDrContract = useMemo(() => {
        const list = contractsResponse?.data ?? [];
        return list.some((c) => c.drValidFlag === true);
    }, [contractsResponse]);

    // const isElectricHome = location.pathname === ROUTES.ELECTRIC.BASE || location.pathname === ROUTES.ELECTRIC.BASE + '/';
    // const isWidePage =
    //     [ROUTES.ELECTRIC.BILLING, ROUTES.ELECTRIC.DR_SCHEDULE].includes(location.pathname) || (isElectricHome && hasDrContract);

    const containerStyle = {
        width: '100%',
        maxWidth: 900,
        padding: 0,
        height: '100%'
    };

    const onLogout = () => {
        logoutMutation.mutate();
    };

    useEffect(() => {
        const token = localStorage.getItem('token');

        if (token && (isLoginPage || isForgetPasswordPage)) {
            const returnPath = getReturnPath();
            const redirectPath = returnPath || ROUTES.ELECTRIC.BASE;
            history.push(redirectPath);
        }
    }, [isLoginPage, isForgetPasswordPage, history]);

    const token = localStorage.getItem('token');
    if (token && (isLoginPage || isForgetPasswordPage)) {
        return null;
    }
    return (
        <Box style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Header isNotPublicPage={isNotPublicPage} onMenuClick={handleDrawerToggle} mobileOpen={mobileOpen} onLogout={onLogout} />
            <Toolbar />

            <Box style={{ display: 'flex', flex: 1 }}>
                <Sidebar mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} onLogout={onLogout} />
                <Box
                    style={{
                        backgroundColor: '#f2f9fc',
                        flex: 1,
                        display: 'flex',
                        padding: '16px',
                        paddingLeft: { xs: '16px', sm: '19px' },
                        marginLeft: isElectricPage && !isMobile ? '250px' : '0',
                        minWidth: 0,
                        overflow: 'hidden'
                    }}
                >
                    {!isMobile && isElectricPage && <Box style={{ flex: 1 }} />}
                    <Container maxWidth={false} style={containerStyle}>
                        {children}
                    </Container>
                    {!isMobile && isElectricPage && <Box style={{ flex: 2 }} />}
                </Box>
            </Box>
            <FloatingBear isLoginPage={isLoginPage} />
            <GlobalNotification />
            {!shouldHideFooter && <Footer isElectricPage={isElectricPage} isMobile={isMobile} />}
        </Box>
    );
};

MainLayout.propTypes = {
    children: PropTypes.node
};

export default MainLayout;
